import AddRemoveTagsAction from "../components/admin/user-tagging/AddRemoveTagsAction";
import User from "../models/user";
import UserSyncStatus from "../models/userSyncStatus";
import UserTag from "../models/userTag";
import UserTagMapping from "../models/userTagMapping";
import httpService from "./httpService";

const apiEndpoint = "/userSync";

const getUserTags = () => {
  return httpService.get<UserTag[]>(`${apiEndpoint}/getUserTags`);
};

const getUserTagMappings = () => {
  return httpService.get<UserTagMapping[]>(`${apiEndpoint}/getUserTagMappings`);
};

const saveUserTagMappings = (userTagMappings: UserTagMapping[]) => {
  return httpService.post<UserTagMapping[]>(
    `${apiEndpoint}/saveUserTagMappings`,
    {
      userTagMappings,
    }
  );
};

const syncUserTags = () => {
  return httpService.get<UserTag[]>(`${apiEndpoint}/syncUserTags`);
};

const getUsersWithTags = () => {
  return httpService.get<User[]>(`${apiEndpoint}/getUsersWithTags`);
};

const getUserSyncStatus = () => {
  return httpService.get<UserSyncStatus[]>(`${apiEndpoint}/getUserSyncStatus`);
};

const scheduleJobTagUsers = (
  tagAction: AddRemoveTagsAction,
  tags: string[],
  emails: string[]
) => {
  return httpService.post(`${apiEndpoint}/scheduleJobTagUsers`, {
    tagAction,
    tags,
    emails,
  });
};

const scheduleJobSyncUsers = () => {
  return httpService.post(`${apiEndpoint}/scheduleJobSyncUsers`);
};

const userSyncService = {
  getUserTags,
  getUserTagMappings,
  saveUserTagMappings,
  syncUserTags,
  getUsersWithTags,
  getUserSyncStatus,
  scheduleJobTagUsers,
  scheduleJobSyncUsers,
};

export default userSyncService;
